import { Button } from './ui/button';
import { Sun, Moon, Monitor } from 'lucide-react';

export const ThemeToggle = ({ theme, onToggle }) => {
  const getIcon = () => {
    switch (theme) {
      case 'light':
        return <Sun className="w-4 h-4" />;
      case 'dark':
        return <Moon className="w-4 h-4" />;
      default:
        return <Monitor className="w-4 h-4" />;
    }
  };

  const getLabel = () => {
    switch (theme) {
      case 'light':
        return 'Light';
      case 'dark':
        return 'Dark';
      default:
        return 'Auto';
    }
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onToggle}
      className="rounded-full gap-2 text-muted-foreground hover:text-foreground"
      data-testid="theme-toggle-btn"
    >
      {getIcon()}
      <span className="text-xs hidden sm:inline">{getLabel()}</span>
    </Button>
  );
};
